module.exports = __webpack_public_path__ + "img/9.cf85b5f.cf85b5f0.png";